import getActions from '../../shared/store/actionsFactory';
import { adminPageNames, adminPageTitles } from '../../shared/adminPageNames';
import getApi from '../../shared/apiFactory';

import Config from '../../../config';
import agGridConfig from '../../../agGridConfig';

import { errorNotification } from '../../../shared/store/notificationActions';
import { fetchingError } from '../../../shared/store/actions';

import {
  importGlJournals as importGlJournalsApi,
  fetchGlAccounts as fetchGlAccountsApi,
  fetchTaxEntryTypes as fetchTaxEntryTypesApi,
  fetchTaxEntryActivities as fetchTaxEntryActivitiesApi,
  fetchSlAccounts as fetchSlAccountsApi,
  fetchSlTaxEntries as fetchSlTaxEntriesApi,
} from '../api';

import {
  FETCH_GL_ACCOUNTS,
  FETCH_GL_ACCOUNTS_SUCCESS,
  FETCH_GL_ACCOUNTS_FAILURE,
  FETCH_TAXENTRY_TYPES,
  FETCH_TAXENTRY_TYPES_SUCCESS,
  FETCH_TAXENTRY_TYPES_FAILURE,
  FETCH_TAXENTRY_ACTIVITIES,
  FETCH_TAXENTRY_ACTIVITIES_SUCCESS,
  FETCH_TAXENTRY_ACTIVITIES_FAILURE,
  FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS,
  FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_SUCCESS,
  FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_FAILURE,
  FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS,
  FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_SUCCESS,
  FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_FAILURE,
  FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL,
  FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL_FINISHED,
  IMPORTING_GL_JOURNALS,
  IMPORTING_GL_JOURNALS_SUCCESS,
  IMPORTING_GL_JOURNALS_FAILURE,
} from './types';

import {
  MIN_COLUMNS_NUMBER,
  MAX_COLUMNS_NUMBER,
  FIELD_MAPPINGS,
} from '../xlsxImport/constants';
import columnHeaders from '../xlsxImport/columnHeaders';
import { normalizeCellToString } from '../../../utils/readXlsxFile.utils';

export const sharedActions = getActions(adminPageNames.GL_JOURNALS, {
  pageTitle: adminPageTitles.GL_JOURNALS,
  api: getApi({
    pageTitle: adminPageTitles.GL_JOURNALS,
    endpoints: {
      FETCH: Config.endpoints.FETCH_GL_JOURNALS,
      INSERT: Config.endpoints.INSERT_GL_JOURNAL,
      UPDATE: Config.endpoints.UPDATE_GL_JOURNAL,
      DELETE: Config.endpoints.DELETE_GL_JOURNAL,
      VALIDATE: Config.endpoints.VALIDATE_GL_JOURNAL,
      IMPORT: Config.endpoints.IMPORT_GL_JOURNAL,
    },
  }),
  sortingField: 'countryTaxType',
  agGridConfig: agGridConfig.adminGlJournals,
  excel: {
    sheetName: 'BSM GL Journal',
    lastColumnLetter: 'M',
    columnHeaders,
    fieldMappings: FIELD_MAPPINGS,
    minColumnsNumber: MIN_COLUMNS_NUMBER,
    maxColumnsNumber: MAX_COLUMNS_NUMBER,
    fieldNormalizers: {
      period: normalizeCellToString,
      line: normalizeCellToString,
      direction: normalizeCellToString,
      glaccountcurrent: normalizeCellToString,
      glaccountprior: normalizeCellToString,
      glaccount2ndprior: normalizeCellToString,
    },
  },
});

export const importGlJournals = (GlJournals, periodName) => async dispatch => {
  dispatch({
    type: IMPORTING_GL_JOURNALS,
  });
  try {
    await importGlJournalsApi(GlJournals, periodName);
    dispatch({
      type: IMPORTING_GL_JOURNALS_SUCCESS,
    });
  } catch (error) {
    dispatch(errorNotification(error.message));
    dispatch({
      type: IMPORTING_GL_JOURNALS_FAILURE,
    });
  }
};

export const fetchGlAccounts = period => async dispatch => {
  dispatch({
    type: FETCH_GL_ACCOUNTS,
  });
  try {
    const response = await fetchGlAccountsApi(period.name);

    return dispatch({
      type: FETCH_GL_ACCOUNTS_SUCCESS,
      glAccounts: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_GL_ACCOUNTS_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchTaxEntryTypes = () => async dispatch => {
  dispatch({
    type: FETCH_TAXENTRY_TYPES,
  });
  try {
    const response = await fetchTaxEntryTypesApi();

    return dispatch({
      type: FETCH_TAXENTRY_TYPES_SUCCESS,
      types: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_TAXENTRY_TYPES_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchTaxEntryActivities = () => async dispatch => {
  dispatch({
    type: FETCH_TAXENTRY_ACTIVITIES,
  });
  try {
    const response = await fetchTaxEntryActivitiesApi();

    return dispatch({
      type: FETCH_TAXENTRY_ACTIVITIES_SUCCESS,
      activities: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_TAXENTRY_ACTIVITIES_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchSlAccounts = period => async dispatch => {
  dispatch({
    type: FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS,
  });
  try {
    const response = await fetchSlAccountsApi(period.name);

    return dispatch({
      type: FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_SUCCESS,
      slAccounts: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_SL_ACCOUNTS_FOR_GL_JOURNALS_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchSlTaxEntries = period => async dispatch => {
  dispatch({
    type: FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS,
  });
  try {
    const response = await fetchSlTaxEntriesApi(period.name);

    return dispatch({
      type: FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_SUCCESS,
      slTaxEntries: response,
    });
  } catch (error) {
    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return dispatch({
        type: FETCH_SL_TAX_ENTRIES_FOR_GL_JOURNALS_FAILURE,
      });
    }
    throw error;
  }
};

export const fetchInitialDataForGlJournalsAddEditModal = period => async dispatch => {
  dispatch({
    type: FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL,
  });

  const actions = [
    fetchGlAccounts(period),
    fetchSlAccounts(period),
    fetchTaxEntryTypes(),
    fetchTaxEntryActivities(),
    fetchSlTaxEntries(period),
  ];

  await Promise.all(actions.map(action => dispatch(action)));

  dispatch({
    type: FETCHING_INITIAL_DATA_FOR_GL_JOURNAL_ADD_EDIT_MODAL_FINISHED,
  });
};
